import * as z from "zod/v4";

export const upsertPostscriptIntegration = {
  name: "upsertPostscriptIntegration" as const,
  input: z.object({ privateApiKey: z.string() }),
  output: z.object({ success: z.boolean() }),
};
